import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import images from '../constants/images';

const faqItems = [
  {
    question: "What services do you offer?",
    answer: "We specialize in premium transportation solutions including executive states transfers, curated local tours, and bespoke travel packages designed to meet individual client requirements."
  },
  {
    question: "How do I book a ride or travel package?",
    answer: "Reservations can be made through our secure online platform, mobile application, or by contacting our 24/7 customer service team. A detailed itinerary will be provided upon confirmation."
  },
  {
    question: "What are your operating hours?",
    answer: <>Our services operate <strong className="font-medium">24/7</strong> throughout the year, ensuring reliable transportation regardless of time or location requirements.</>
  },
  {
    question: "Can I schedule rides in advance?",
    answer: "Advanced reservations are recommended and can be arranged up to 6 months prior to your required service date through our digital platforms."
  },
  {
    question: "What is your cancellation policy?",
    answer: "Cancellations made 24 hours prior to service incur no charges. Late cancellations may be subject to a fee proportional to the scheduled service value."
  },
  {
    question: "Are your vehicles insured and maintained?",
    answer: "All vehicles undergo daily inspections and adhere to strict maintenance schedules, with full commercial insurance coverage for passenger safety."
  },
  {
    question: "What safety measures are in place?",
    answer: "We implement comprehensive safety protocols including driver background checks, vehicle sanitization between rides, and real-time journey tracking."
  },
  {
    question: "Do you offer any discounts or loyalty programs?",
    answer: "Frequent clients benefit from our loyalty program with tiered rewards, while corporate accounts receive volume-based pricing advantages."
  },
  {
    question: "How do I contact customer support?",
    answer: "Our multilingual support team is available via phone (+1-800-555-1234), email (support@company.com), or through our live chat platform."
  },
  {
    question: "What if I have more questions?",
    answer: "Our comprehensive help center contains detailed service information, or you can request a callback from our customer experience team."
  }
];

const Faq = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <div 
        className="bg-fixed bg-cover bg-center backdrop-blur-sm" 
        style={{ backgroundImage: `url(${images.faqbg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
      >
        <Navbar />
        <main className="flex-grow px-2 py-4 md:py-16">
          <section className="max-w-5xl mx-auto">
            <header className="mb-12 text-center">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 animate-fade-in-up">
                Frequently Asked Questions
              </h1>
              <p className="text-lg text-gray-600">
                Find answers to common queries about our services and operations
              </p>
            </header>

            {/* Single White Background Container for FAQs */}
            <div className="bg-white p-6 md:p-8 rounded-lg shadow-sm transition-all hover:shadow-md animate-fade-in-up w-full">
              {faqItems.map((item, index) => (
                <div key={item.question} className="mb-6">
                  <h2 className="text-xl font-semibold text-gray-800 mb-2">
                    {item.question}
                  </h2>
                  <p className="text-gray-600 leading-relaxed">
                    {item.answer}
                  </p>
                  {index !== faqItems.length - 1 && <hr className="my-4 border-gray-300" />}
                </div>
              ))}
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default Faq;
